import React from 'react';
import { IAsset } from '../AssetViewerModal';

import { ImageViewer, UnsupportedViewer, VideoViewer } from './content-type-viewer';
import { resolveViewerName } from './resolve-viewer-name';

export interface AssetViewerProps {
    currentAsset: IAsset;
    containerRef: HTMLDivElement | null;
}

export function AssetViewer({ currentAsset, containerRef }: AssetViewerProps) {
    const viewerName = resolveViewerName(currentAsset);
    const imageUrl = currentAsset.downloadUrl || currentAsset.thumbnailUrl || '';
    const imageAsset = viewerName === 'image' ? { src: imageUrl, alt: currentAsset.name } : null;

    return (
        <>
            {/* ImageViewer stays mounted across asset changes as react-viewer manages its own DOM. */}
            <ImageViewer image={imageAsset} container={containerRef} />

            {viewerName === 'video' && (
                <VideoViewer fileName={currentAsset.name} videoUrl={currentAsset.downloadUrl ?? ''} />
            )}

            {viewerName === 'unsupported' && (
                <UnsupportedViewer fileName={currentAsset.name} contentType={currentAsset?.contentType} />
            )}
        </>
    );
}
